import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardTitle from "@saleor/components/CardTitle";
import MultiChipsSelectField from "@saleor/components/MultiChipsSelectField";
import { MultiAutocompleteChoiceType } from "@saleor/components/MutliTagAutoCompleteField";
import { BrandErrorFragment } from "@saleor/fragments/types/BrandErrorFragment";
import { FetchMoreProps } from "@saleor/types";
import React, { useState } from "react";
import { useIntl } from "react-intl";

import { BrandGroupFormData } from "../BrandGroupDetailsPage";

interface BrandGroupSearchTagsProps {
  data: BrandGroupFormData;
  disabled?: boolean;
  tags?: MultiAutocompleteChoiceType[];
  errors: BrandErrorFragment[];
  fetchMoreTags?: FetchMoreProps;
  fetchTags?: (query: string) => void;
  onChange(event: any);
}

export const BrandGroupSearchTags: React.FC<BrandGroupSearchTagsProps> = props => {
  const { data, tags, onChange, fetchMoreTags, fetchTags } = props;
  const intl = useIntl();

  const [tagText, setTagText] = useState("");
  const filterdTags = tags.filter(
    tag => !data.tags.map(tag => tag.label).includes(tag.label)
  );

  const handleChangeTag = e => {
    const getValue = e.target.value;
    const getAllTags = [...data.tags];
    const findTag = tags.filter(tag => tag.value === getValue)[0];
    const newEvent = {
      target: { name: "tags", value: [...getAllTags, findTag] }
    };
    const isDuplicate = getAllTags.find(
      currentTags => currentTags?.value === findTag?.value
    );
    if (!isDuplicate && findTag !== undefined) {
      onChange(newEvent);
    }
  };
  const handleRemoveTag = e => {
    const getValue = e.target.value;
    const getAllTags = [...data.tags];
    const newTags = getAllTags.filter(tag => tag.value !== getValue);
    const newEvent = { target: { name: "tags", value: newTags } };
    onChange(newEvent);
  };

  const handleTagAdd = () => {
    if (tagText !== "") {
      const findTag = tags?.filter(tag => tag.label === tagText);
      const findSelectedTag = data.tags.filter(tag => tag.label === tagText);
      if (findTag.length === 0 && findSelectedTag.length === 0) {
        return {
          label: tagText,
          onClick: () => {
            const newEvent = {
              target: {
                name: "tags",
                value: [...data.tags, { label: tagText, value: tagText }]
              }
            };
            onChange(newEvent);
          },
          value: tagText
        };
      }
    }
    return null;
  };

  const handleKeyPress = e => {
    if (/[`[ /!@#$%^&*()_+\=\]{};:"\\|,.<>?~]/.test(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Card>
      <CardTitle title="Tags" />
      <CardContent>
        <MultiChipsSelectField
          disabled={false}
          add={handleTagAdd()}
          displayValues={data.tags}
          label={intl.formatMessage({
            defaultMessage: "Search Tags"
          })}
          choices={filterdTags}
          limit={10}
          name="tags"
          value={data.tags.map(tag => tag.label)}
          onChange={handleChangeTag}
          onChangeText={setTagText}
          onRemove={handleRemoveTag}
          fetchChoices={fetchTags}
          onKeyPress={handleKeyPress}
          onFetchMore={fetchMoreTags?.onFetchMore}
          hasMore={fetchMoreTags.hasMore}
          loading={fetchMoreTags.loading}
        />
      </CardContent>
    </Card>
  );
};
export default BrandGroupSearchTags;
